import React, { useState } from 'react';
import { Button as AdminButton, useRecordContext } from 'react-admin';
import { FUNCTION_URL } from '../../../Constants/index';
import ResultDialog from '../../../Utilities/ResultDialog';

function ValidateRegman () {
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);

    const record = useRecordContext();

    const handleResultClose = () => {
        setResultDialogOpen(false);
        setResultDialogRows([]);
        setResultDialogHeaders([]);
        setResultLoading(false);

        if (window.location.hash.includes('devices_daesaminare')) {
            document.querySelectorAll('button').forEach(b => { 
                if(b.getAttribute('aria-label') === 'Aggiorna') { 
                    b.click(); 
                }
            })
        }
        else {
            window.location.replace(window.location.origin + '/#/devices');
        }
    }


    const handleOpen = async () => {
        setResultDialogOpen(true);
        setResultLoading(true);

        await fetch(FUNCTION_URL + '/getinfocpe/' + record.id, {
            method: 'GET',
            headers: {
                'x-zumo-auth': localStorage.getItem('auth-token')
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.text().then(text => {
                        if (text !== '') {
                            let body = JSON.parse(text)
                            if (body && body.result === 'OK') {
                                setResultDialogOpen(true);
                                setResultDialogRows([[body.status_descrizione, body.status_regman_descrizione]]);
                                setResultDialogHeaders(["Stato", "Stato Regman"]);
                                setResultLoading(false);
                            }
                            else if (body && body.result !== 'OK') {
                                setResultDialogOpen(true);
                                setResultDialogRows([["Il Sistema Regman ha risposto con un errore"]]);
                                setResultDialogHeaders(["Errore"]);
                                setResultLoading(false);
                            }
                        }

                    });
                }
                else {
                    setResultDialogOpen(true);
                    setResultDialogRows([["Il Sistema Regman non è disponibile"]]);
                    setResultDialogHeaders(["Errore"]);
                    setResultLoading(false);   
                }
            })
            .catch(error => {
                console.log(error);
                return error;
            });
    }

    return (
        <div>
            <AdminButton label='tim.validateregman.button_label' onClick={handleOpen.bind(this)} >
            </AdminButton>
            <ResultDialog
                open={resultDialogOpen}
                rows={resultDialogRows}
                headers={resultDialogHeaders}
                loading={resultLoading}
                title="Risultati"
                onClose={handleResultClose} >
                {!resultLoading && <AdminButton label='tim.uploadfile.close' onClick={handleResultClose.bind(this)} color="primary"></AdminButton>}
            </ResultDialog>

        </div>
    );
}
export default ValidateRegman;